<div class="wrapper h-full m-auto pl-2 pr-2">
  <div class="max-h-full flex flex-col p-4 rounded-sm bg-emphasis overflow-auto">
    <span class="text-xl font-bold">{{ 'requests.title' | translate }}</span>

    @if (loadingPage()) {
      <div class="w-full mt-52 flex justify-center">
        <p-progress-spinner ariaLabel="loading" />
      </div>
    } @else {
      @if (loadingError()) {
        <div class="flex flex-col items-center">
          <mat-icon [size]="100" color="var(--p-red-400)">error_outlined</mat-icon>
          <div class="mt-8 text-2xl text-red-400">{{ loadingError() }}</div>
        </div>
      } @else {
        @if (submitSuccess()) {
          <div class="flex flex-col items-center mt-8">
            <mat-icon [size]="100" color="var(--p-green-400)">check_circle</mat-icon>
            <div class="mt-8 text-2xl">{{ 'requests.successDescription' | translate }}</div>
            <p-button class="mt-8" [outlined]="true" [label]="'general.home' | translate" routerLink="/" />

          </div>
        } @else {
          <span class="mb-4">{{ 'requests.description' | translate }}</span>

          <p-fluid>
            <form [formGroup]="requestForm" class="flex flex-col gap-2">
              <p-floatlabel variant="on">
                <input pInputText formControlName="name" autocomplete="off" />
                <label>{{ 'internal.requests.name' | translate }}</label>
              </p-floatlabel>

                <div class="flex flex-row gap-4 justify-between flex-desktop">
                  <div>
                    <label>{{ 'internal.requests.startDate' | translate }}</label>
                    @defer (on viewport) {
                    <p-datepicker
                      formControlName="startdate"
                      showIcon
                      iconDisplay="input"
                      [showTime]="true"
                      [inline]="true"
                      [showButtonBar]="true"
                      hourFormat="24"
                    />
                    } @placeholder {
                      <div></div>
                    }
                  </div>

                  <div>
                    <label>{{ 'internal.requests.endDate' | translate }}</label>
                    @defer (on viewport) {
                    <p-datepicker
                      formControlName="enddate"
                      showIcon
                      iconDisplay="input"
                      [minDate]="requestForm.value.startdate"
                      [showTime]="true"
                      [inline]="true"
                      [showButtonBar]="true"
                      hourFormat="24"
                    />
                    } @placeholder {
                      <div></div>
                    }
                  </div>
                </div>

              @defer (hydrate on viewport) {
                <div class="flex flex-col gap-4 flex-mobile">
                  <p-floatlabel variant="on">
                    @defer (on viewport) {
                    <p-datepicker
                      formControlName="startdate"
                      showIcon
                      iconDisplay="input"
                      [showTime]="true"
                      [touchUI]="true"
                      [showButtonBar]="true"
                      hourFormat="24"
                    />
                    } @placeholder {
                      <div></div>
                    }
                    <label>{{ 'internal.requests.startDate' | translate }}</label>
                  </p-floatlabel>

                  <p-floatlabel variant="on">
                    @defer (on viewport) {
                    <p-datepicker
                      formControlName="enddate"
                      showIcon
                      iconDisplay="input"
                      [minDate]="requestForm.value.startdate"
                      [showTime]="true"
                      [touchUI]="true"
                      [showButtonBar]="true"
                      hourFormat="24"
                    />
                    } @placeholder {
                      <div></div>
                    }
                    <label>{{ 'internal.requests.endDate' | translate }}</label>
                  </p-floatlabel>
                </div>
              }

              <p-floatlabel variant="on">
                <input pInputText formControlName="location" autocomplete="off" />
                <label>{{ 'internal.requests.location' | translate }}</label>
              </p-floatlabel>

              <div class="flex flex-row gap-4 flex-mobile-col">
                <p-floatlabel variant="on" class="w-full">
                  <input pInputText formControlName="contact" autocomplete="off" />
                  <label>{{ 'internal.requests.contact' | translate }}</label>
                </p-floatlabel>

                <p-floatlabel variant="on" class="w-full">
                  <input pInputText formControlName="contactMail" autocomplete="off" />
                  <label>{{ 'internal.requests.contactMail' | translate }}</label>
                </p-floatlabel>
              </div>

              <p-floatlabel variant="on">
                <textarea
                  pTextarea
                  formControlName="equipment"
                  rows="10"
                  cols="30"
                  style="resize: none"
                  class="h-full"
                ></textarea>
                <label>{{ 'internal.requests.equipment' | translate }}</label>
              </p-floatlabel>
            </form>
          </p-fluid>
          <div class="flex items-center justify-end gap-2">
            <p-button
              [label]="'requests.submit' | translate"
              [disabled]="!requestForm.valid"
              [loading]="submittingRequest()"
              (onClick)="submitRequest()"
            />
          </div>
        }
      }
    }
  </div>
</div>
